/** Checking for empties such that TS actually realizes that we have checked */
export function notEmpty<V>(value: V | null | undefined): value is V {
  return value !== null && value !== undefined;
}
